<template>
    <div>
        <div class="container" style="width:100%;">
            <div style="font-size:20px;"><i class="el-icon-s-unfold grid-con-icon"></i><span style="margin-left:5px;">培训管理</span></div>

            <el-form :model="form" inline  style="padding-left:8px;margin-top:-20px;">
                <div style="display:flex;justify-content:flex-end;">
                    <el-button @click="onEditPlanClick(null)" type="primary">新建培训</el-button>
                </div>
                <el-row  type="flex" style="margin-top:15px;" align="center">
                    <el-form-item label="培训日期" style="width: 500px;">
                            <el-date-picker
                                    v-model="form.dateArray"
                                    type="daterange"
                                    range-separator="至"
                                    value-format="yyyy-M-d"
                                    start-placeholder="年/月/日"
                                    end-placeholder="年/月/日">
                            </el-date-picker>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="培训类型">
                        <el-select v-model="form.typeArr" style="width:400px;" clearable multiple  placeholder="请选择">
                            <el-option v-for="item in trainTypeList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="关键字">
								<el-input v-model="form.key" class="text-width"></el-input>
					</el-form-item>
                    <!--  -->
                    <el-button @click="onQuery" type="primary">检索</el-button>
                </el-row>
            </el-form>

            <el-table 
                :data="trainList.slice((currentPage-1)*PageSize,currentPage*PageSize)" 
                border :header-cell-style="{background:'#eef1f6',color:'#606266'}" height="800"
                        style="width: 80%;margin-top: 10px;" ref="Table" >
                <el-table-column prop="clientName" align="center" sortable  label="终端客户" ></el-table-column>
                <el-table-column prop="trainDate" align="center" sortable  label="培训日期" ></el-table-column>                               
                <el-table-column prop="topic" align="center" sortable label="培训主题" ></el-table-column>
                <el-table-column prop="attendCnt" align="center" sortable width="170" label="参会人数" ></el-table-column>                
                <el-table-column prop="answerCnt" align="center" sortable width="110" label="问卷人数" ></el-table-column>    
                <el-table-column align="center" sortable width="110" label="对应计划" >
                    <template slot-scope="scope" >
                        <span class="hotlink">{{scope.row.planTopic}}</span>
                    </template>
                </el-table-column>    
                <el-table-column prop="orderCode" align="center" sortable  label="关联订单" ></el-table-column>              
                <el-table-column prop="rowTime" align="center" sortable width="160" label="创建时间" ></el-table-column>
                <el-table-column align="center" width="140" label="编辑" >
                    <template slot-scope="scope" >
                        <el-button type="text" @click="onEditPlanClick(scope.row)">修改</el-button>                        
                        <el-button type="text" style="color:red;" @click="onDelClick(scope.row)">删除</el-button>
                    </template>
                </el-table-column>                 
            </el-table>

            <div class="tabListPage">
                <el-pagination @size-change="handleSizeChange" 
                                @current-change="handleCurrentChange" 
                                :current-page="currentPage" 
                                :page-sizes="pageSizes" 
                                :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" 
                                :total="totalCount">
                    </el-pagination>
            </div>

            <el-dialog title="新建/编辑培训" :visible="editDialogVisible" width="60%"
                                :modal-append-to-body='false'
                                :close-on-click-modal='false'
                                @close="editDialogVisible = false" 
                                append-to-body>
                    <el-form :model="editForm" inline >
                        <el-row>
                            <el-form-item label="培训主题">
                                <el-input v-model="editForm.topic" class="text-width"></el-input>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item label="培训日期" style="width: 500px;">
                                <el-date-picker
                                    v-model="editForm.trainDate"
                                    type="date"
                                    placeholder="选择日期">
                                </el-date-picker>                                 
                            </el-form-item>
                            <el-form-item label="培训类型">
                                <el-select v-model="editForm.typeArr" filterable multiple style="width:300px" placeholder="请选择">
                                    <el-option v-for="item in trainTypeList" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item label="是否经销商培训">
                                <el-checkbox v-model="editForm.isAgent">是</el-checkbox>
                            </el-form-item>
                            <el-form-item v-if="editForm.isAgent" label="经销商名称">
                                <el-select v-model="editForm.agentId" filterable  style="width:300px" @change="onClientChange" placeholder="请选择">
                                    <el-option v-for="item in agentDictList" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item label="终端客户">
                                <el-select v-model="editForm.companyId" filterable  style="width:300px" @change="onClientChange" placeholder="请选择">
                                    <el-option v-for="item in clientDictList" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="关联计划">
                                <el-select v-model="editForm.planId" clearable   style="width:600px" placeholder="请选择">
                                    <el-option v-for="item in planDicList" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-row>  
                        <el-row>
                            <el-form-item label="参会人数">
                                <el-input-number v-model="editForm.attendCnt" :min="1" label="选择参会人数"></el-input-number>
                            </el-form-item>
                            <el-form-item label="问卷回收人数">
                                <el-input-number v-model="editForm.answerCnt" :min="0" label="选择问卷回收人数"></el-input-number>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <my-upload-file-form-item v-model="editForm.sampleArr" label="附件" :limit="10" />
                        </el-row>       
                        <el-row>
                            <el-form-item label="备注">
                                <el-input v-model="editForm.remark" size="medium" :rows="8" type="textarea"
                                    autocomplete="off" placeholder="" style="width:1000px"
                                    ></el-input>
                            </el-form-item>
                        </el-row>           
                    </el-form>
                    <div slot="footer" style="display:flex;justify-content:center;margin-top:20px;">
                        <el-button @click="editDialogVisible = false">关闭</el-button>
                        <el-button style="margin-left:20px;" type="primary" @click="onSaveTrain">保存</el-button>
                    </div> 
                
                </el-dialog>


            <!-- 培训：
培训主题
参会最终用户名称
培训日期
参会人数
填写问卷人数 -->
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCurrentYMD ,getNextAndBeforeHalfYearDateArray} from "@/utils/time";
import MyUploadFileFormItem from "@/components/MyUploadFileFormItem";
import {getSampleArrayFromSever,getSampleLogStrToSever} from "@/utils/tools";
import {ZC_SaveTrain,ZC_DelTrain} from "@/api/zc";
import { getToken } from "@/utils/auth";

export default {
    name: 'baseform',
    components: {
        MyUploadFileFormItem
      },
    computed: {
        ...mapGetters(['clientDictList','planList','trainTypeList','trainList','agentDictList'])
    },
    data() {
        return {
            form: {    
                dateArray:getNextAndBeforeHalfYearDateArray({}),
                // isValidDate:true,
                typeArr:[],
                // productArr:[],
                key:'',
            },            
            props: { multiple: true },
            // 默认显示第几页
            currentPage:1,
            // 总条数，根据接口获取数据长度(注意：这里不能为空)
            totalCount:0,
            // 个数选择器（可修改）
            pageSizes:[20,50,100],
            // 默认每页显示的条数（可修改）
            PageSize:50,

            // typeList:['aaa','bbb'],
            curItem:{},
            editDialogVisible:false,
            editForm:{
                id:'',
                topic:'',
                trainDate:getCurrentYMD(),
                typeArr:[],
                companyId:'',
                planId:'',
                attendCnt:0,
                answerCnt:0,
                remark:'',
                sampleArr:[],
                isAgent:false,
                agentId:'',
            },
            planDicList:[],
        };
    },

    async mounted() {
        await this.$store.dispatch('zc/clientDictList');     
        await this.$store.dispatch('zc/trainTypeList');    
        await this.$store.dispatch('zc/agentDictList');
        // console.log('trainTypeList',this.trainTypeList) 
        this.onQuery();
    },


    methods: {
        async onEditPlanClick(item){
            // console.log('item',item)
            if (!item){
                this.editForm.id='';
                this.editForm.topic='';
                this.editForm.trainDate=getCurrentYMD();
                this.editForm.typeArr=[];                
                this.editForm.companyId='';
                this.editForm.planId='',
                this.editForm.attendCnt=0;                
                this.editForm.answerCnt=0;
                this.editForm.remark='';
                this.editForm.sampleArr=[];
                this.editForm.isAgent=false;
                this.editForm.agentId='';
            }else{
                this.editForm=JSON.parse(JSON.stringify(item));
                // this.editForm.dateArray=[item.planSDate,item.planEDate];
                this.editForm.typeArr=[];
                // var tmpArr[]=this.editForm.typeIds.split(',');
                
                this.editForm.typeIds.split(',').forEach(ele=>{
                   this.editForm.typeArr.push(ele*1);  
                })
                this.onClientChange().then(()=>{                    
                    this.editForm.planId=item.planId;
                })
                var samples = this.editForm.samples;
                this.editForm.sampleArr=getSampleArrayFromSever({samples});
            }
            this.editDialogVisible=true;
        },

        async onClientChange(){
            const {companyId} = this.editForm;
            this.editForm.planId='';
            await this.$store.dispatch("zc/planList", {
                companyId,  
                sDate:'2022-1-1',   
                eDate:'2099-12-31',           
            }).then(res=>{
                this.planDicList=[];
                this.planList.forEach(ele=>{
                    if (ele.cate1=='培训支持'){
                        this.planDicList.push({value:ele.id,label:ele.topic+'('+ele.shortPlanSDate+'~'+ele.shortPlanEDate+')'})
                    }
                })               
                
            });
        },

        async onDelClick(item){
            this.$confirm('是否确认删除？ 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {    
                        await ZC_DelTrain({userId: getToken(),id:item.id}).then(()=>{
                        this.onQuery();              
						this.$message.success('删除成功');
					})
                    })
        },

        async onSaveTrain(){
            const {id,isAgent,agentId,topic,trainDate,typeArr,companyId,planId,attendCnt, answerCnt,remark,sampleArr} = this.editForm;
            if (!topic.trim() ) {
                this.$message.warning('请输入培训主题')
                return;
            }
            if (!trainDate) {
                this.$message.warning('请选择培训日期')
                return;
            }
            if (typeArr?.length<1) {
                this.$message.warning('请选择培训类型')
                return;
            }
            if (!isAgent && !companyId) {
                this.$message.warning('请选择终端客户')
                return;
            }
            if (isAgent && !agentId) {
                this.$message.warning('请选择经销商')
                return;
            }

            var typeIds='';
            if (typeArr.length>0){
                typeIds=typeArr.join(',');
            }
            
            // if (!topic?.trim()) {
            //     this.$message.warning('请输入服务主题')
            //     return;
            // }
            // if (!content?.trim()) {
            //     this.$message.warning('请输入服务内容')
            //     return;
            // }
            var samples = getSampleLogStrToSever({sampleArr})
            // console.log('aa',sampleArr,samples)
            await ZC_SaveTrain({id,isAgent,agentId,companyId,topic,trainDate,typeIds,attendCnt, answerCnt,planId,remark,samples});
            this.$message.success('保存成功');
            this.onQuery();
            this.editDialogVisible=false;
        },

       async onQuery(){
        console.log('form',this.form)
        const {dateArray:[sYM, eYM],typeArr,key} = this.form;
        var typeIds='';
        var sDate = new Date(sYM+'').toLocaleDateString();
        var eDate = new Date(eYM+'').toLocaleDateString();

        // console.log('aa',typeArr)
        if (typeArr.length>0){
            typeIds=typeArr.join(',');
        }

        // console.log('aa',sDate,eDate,this.productSearchForm);
        await this.$store.dispatch("zc/trainList", {
            sDate,
            eDate,
            typeIds,
            key,
        }).then(res=>{
            this.$refs.Table.doLayout();
            this.totalCount=this.trainList.length;
            this.currentPage=1;
            
        });

       },

       // 每页显示的条数
        handleSizeChange(val) {
        // 改变每页显示的条数 
        this.PageSize=val
        // 注意：在改变每页显示的条数时，要将页码显示到第一页
        this.currentPage=1
        },
        // 显示第几页
        handleCurrentChange(val) {
            // 改变默认的页数
            this.currentPage=val;
        },

    }
};
</script>

<style scoped>
</style>